import React from 'react';

import {
  AccordionItem,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const FaqItemDetail = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');

  return (
    <AccordionItem
      key={title}
      title={title}
      content={body}
      duration={100}
      easing="cubic-bezier(0.33, 1, 0.68, 1)"
    />
  );
};

export default FaqItemDetail;
